import { render } from "./Influencev2.vue?vue&type=template&id=4f8b209c"
import script from "./Influencev2.vue?vue&type=script&lang=js"
export * from "./Influencev2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__